<template>
    <div class="splide relative">
        <div
            class="sw-slider-arrows absolute top-0 left-0 z-0 hidden p-0 lg:block"
        >
            <div class="splide__arrows flex w-full justify-between">
                <button class="splide__arrow splide__arrow--prev">
                    <i class="sw-icons-sm-arrow-light-left"></i>
                </button>
                <button class="splide__arrow splide__arrow--next">
                    <i class="sw-icons-sm-arrow-light-right"></i>
                </button>
            </div>
        </div>
        <div class="splide__track relative z-20">
            <ul class="splide__list">
                <slot />
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CalendarMiniSliderLayout'
};
</script>
